module.exports = __webpack_public_path__ + "static/media/laravel.ea780fe4.svg";